import axios, { AxiosResponse } from 'axios';
import { Result } from '../../../core/models/Result';

const API_URL = process.env.REACT_APP_MANUFACTURING_API_URL;

// The order controller's URL segment.
export type WorkOrderResource =
  | 'castingorder'
  | 'kadifittingorder'
  | 'polishingorder'
  | 'motipiroingorder'
  | 'motifittingorder'
  | 'pastingorder'
  | 'packingorder';

export type VendorUpdate = {
  id: number;
  updateType: number;
  notes?: string | null;
  revisedDeliveryDate?: string | null;
  createdOn: string;
};

// Mirrors WorkOrderVendorUpdateType on the server.
export const VENDOR_UPDATE_TYPES: Record<number, string> = {
  1: 'Material received',
  2: 'In progress',
  3: 'Ready for pickup',
};

export const sendWorkOrderWhatsApp = (resource: WorkOrderResource, id: number): Promise<Result> =>
  axios
    .post(`${API_URL}/${resource}/${id}/send-whatsapp`)
    .then((response: AxiosResponse<Result>) => response.data)
    .catch((err: Result) => err);

export const getVendorUpdates = (
  resource: WorkOrderResource,
  id: number
): Promise<VendorUpdate[]> =>
  axios
    .get(`${API_URL}/${resource}/${id}/vendor-updates`)
    .then((response: AxiosResponse<VendorUpdate[]>) => response.data);
